<template>
  <!-- v-loading="loading"
    element-loading-text="拼命打印中"
    element-loading-background="rgba(0, 0, 0, 0.8)" -->
  <el-dialog
    title="选择打印信息"
    :visible.sync="visible"
    width="400px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      label-width="90px">
      <el-form-item
        label="打印机"
        prop="index"
        :rules="{
          required: true, message: '打印机不能为空', trigger: 'change'
        }">
        <el-select
          v-model="ruleForm.index"
          placeholder="请选择打印机">
          <el-option
            v-for="item in list"
            :key="item.index"
            :label="item.name"
            :value="item.index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="纸张"
        prop="pageSize"
        :rules="{
          required: true, message: '纸张不能为空', trigger: 'change'
        }">
        <el-select
          v-model="ruleForm.pageSize"
          placeholder="请选择纸张">
          <el-option
            v-for="(item, index) in pagelist"
            :key="index"
            :label="item.name"
            :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="方向"
        prop="intOrient"
        :rules="{
          required: true, message: '纸张方向不能为空', trigger: 'change'
        }">
        <el-select
          v-model="ruleForm.intOrient"
          placeholder="请选择纸张方向">
          <el-option
            :key="1"
            label="纵(正)向打印"
            :value="1"></el-option>
          <el-option
            :key="2"
            label="横向打印"
            :value="2"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        type="primary"
        @click="addItem">确定</el-button>
      <el-button
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
// import CateEditModal from './cate-edit-modal.vue'
import { printTemplate } from '../printTemplate.js'
import getLodop from '@/utils/LodopFuncs'
import { doConnect } from '../../../utils/douyinPrinterPluins'
export default {
  name: 'PrinterSelectModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      visible: false,
      // loading: false,
      // loading1: false,
      list: [],
      ruleForm: {
        index: 0,
        pageSize: null,
        intOrient: 1
      },
      printList: []
      // task: [],
      // t: null
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    }),
    pagelist() {
      const item = this.list.find(i => i.index === this.ruleForm.index) || {}
      return item.pagelist || []
    }
  },
  watch: {
    'ruleForm.index'() {
      this.ruleForm.pageSize = null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {},
    // tick() {
    //   const list = getTaskList()
    //   if (list.length > 0 && list.every(i => i.done)) {
    //     console.log('done')
    //     clearTimeout(this.t)
    //     return
    //   }
    //   this.task = list
    //   this.t = setTimeout(() => {
    //     this.tick()
    //   }, 1000)
    // },
    addItem() {
      // this.loading1 = true
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const ruleForm = { ...this.ruleForm, printer: this.list[this.ruleForm.index].name }
          printTemplate(this.printList, ruleForm, this)
        } else {
          // this.loading1 = false
        }
      })
    },
    async fetch(rows) {
      console.log(rows)
      try {
        this.printList = rows
        const LODOP = getLodop()
        if (!LODOP) {
          return
        }
        await doConnect()
        console.log(LODOP.Printers)
        this.list = LODOP.Printers.list.map((i, index) => ({ ...i, index }))
        this.ruleForm.index = +LODOP.Printers.default
        this.toggleModal(true)
      } catch (error) {
        // this.$message.error(error)
        console.log(error)
        if (error.errorMessage) {
          this.$message.error(error.errorMessage)
        }
      }
    }
  }
}
</script>
